import React, { useEffect, useState } from "react";

const VariantStatusModal = ({ show, onClose, variants, onSave, itemName }) => {
  const [localVariants, setLocalVariants] = useState([]);

  useEffect(() => {
    setLocalVariants(variants || []);
  }, [variants]);

  const toggleVisibility = (index) => {
    setLocalVariants((prev) => {
      const updated = [...prev];
      const currentStatus =
        updated[index].visibility || updated[index].isVisible;
      const nextStatus = currentStatus === "Y" ? "N" : "Y";

      updated[index] = {
        ...updated[index],
        visibility: nextStatus,
        isVisible: nextStatus,
      };
      return updated;
    });
  };

  if (!show) return null;

  return (
    <>

    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 montserrat-font-1">
      <div className="bg-white w-[600px] rounded-lg shadow-lg montserrat-font-1">
        {/* HEADER */}
        <div className="flex justify-between items-center border-b px-4 py-3">
          <h2 className="font-semibold text-lg">
            Variants Status — {itemName}
          </h2>
          <button onClick={onClose}>✕</button>
        </div>

        {/* BODY */}
        <div className="max-h-[400px] overflow-y-auto px-4 montserrat-font-1">
          {localVariants.length === 0 ? (
            <p className="text-center py-10">No Variants</p>
          ) : (
            <>
              {localVariants.length > 0 && (
                <div className="flex justify-between items-center border p-2 mb-4 bg-gray-100 rounded sticky top-0 z-20 shadow-md">
                  <h1
                    style={{
                      color:
                        localVariants[0].visibility === "Y" ? "green" : "red",
                    }}
                    className="font-bold"
                  >
                    Item Visible:{" "}
                    {localVariants[0].visibility === "Y" ? "Yes" : "No"}
                  </h1>
                  <h1
                    style={{
                      color: localVariants[0].inStock === "Y" ? "green" : "red",
                    }}
                    className="font-bold"
                  >
                    Stock: {localVariants[0].inStock === "Y" ? "Y" : "N"}
                  </h1>
                </div>
              )}

              {localVariants.map((v, i) => (
                <div key={v.row_id || i} className="border rounded-lg p-3 mb-3 montserrat-font-1">
                  <div className="flex justify-between items-center">
                    <div>
                      <h3 className="font-medium">
                        {v.variant_name || v.size} — ₹{v.price}
                      </h3>
                      <p className="text-xs text-gray-500">Row ID: {v.id}</p>
                    </div>

                    <div className="flex gap-2">
                      <span
                        className={`text-white text-xs px-2 py-1 rounded ${v.visibility === "Y" ? "bg-green-500" : "bg-red-500"}`}
                      >
                        Visible: {v.visibility}
                      </span>
                      <span
                        className={`text-white text-xs px-2 py-1 rounded ${v.inStock === "Y" ? "bg-blue-500" : "bg-gray-500"}`}
                      >
                        Stock: {v.inStock === "Y" ? "IN" : "OUT"}
                      </span>
                    </div>
                  </div>

                  <div className="flex justify-between items-center mt-3 montserrat-font-1">
                    <div className="flex items-center gap-3">
                      <span
                        className={`text-sm font-semibold uppercase ${
                          v.visibility === "Y" || v.isVisible === "Y"
                            ? "text-green-600"
                            : "text-red-600"
                        }`}
                      >
                        {v.visibility === "Y" || v.isVisible === "Y"
                          ? "Visible"
                          : "Hidden"}
                      </span>

                      <button
                        onClick={() => toggleVisibility(i)}
                        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-200 focus:outline-none ${
                          v.visibility === "Y" || v.isVisible === "Y"
                            ? "bg-green-500"
                            : "bg-red-500"
                        }`}
                      >
                        <span
                          className={`inline-block h-4 w-4 transform rounded-full bg-white transition duration-200 ${
                            v.visibility === "Y" || v.isVisible === "Y"
                              ? "translate-x-6"
                              : "translate-x-1"
                          }`}
                        />
                      </button>
                    </div>

                    <button
                      onClick={() => onSave(localVariants[i])}
                      className="bg-blue-600 text-white px-4 py-1 rounded hover:bg-blue-700"
                    >
                      Save
                    </button>
                  </div>
                </div>
              ))}
            </>
          )}
        </div>

        {/* FOOTER */}
        <div className="flex justify-end border-t px-4 py-3">
          <button onClick={onClose} className="border px-4 py-1 rounded">
            Close
          </button>
        </div>
      </div>
    </div>
    </>
  );
};

export default VariantStatusModal;
